import { sendError } from '../plugins/sentry';
import { Opt, OptType } from '/@types/opt';

export function createQueryParams(properties: Map<string, any>) {
  const query = new URLSearchParams();

  [...properties].forEach(([name, value]) => {
    if (value == null || (typeof value === 'string' && value.length === 0)) return;

    if (typeof value === 'object') {
      [...value].forEach((val) => {
        if (!val) return;
        query.append(name, val);
      });
    } else {
      query.append(name, value);
    }
  });
  return query;
}

export function filterQuery(opt: Opt, columns: Array<any /*Column*/>): URLSearchParams {
  const searchParams = new URLSearchParams();
  const nFilters = opt.filters.filter(({ columnId }) => typeof columnId === 'number');
  const sFilters = opt.filters.filter(({ columnId }) => typeof columnId !== 'number');

  if (opt.type == OptType.List) {
    searchParams.append('limit', String(opt.limit));
    searchParams.append('offset', String(opt.offset));
    searchParams.append('orderBy', String(opt.sortBy));
    searchParams.append('orderDesc', String(opt.sortDesc));
  }

  if (opt.type === OptType.Map) {
    searchParams.append('limit', String(100_000)); // 100_000 is max limit from API
  }

  if (opt.search.length > 0) {
    searchParams.append('search', String(opt.search));
  }

  if (opt.tenantId != null) {
    searchParams.append('partnerId', String(opt.tenantId));
  }

  if (nFilters.length > 0) {
    const base64 = btoa(
      JSON.stringify(
        nFilters.map(({ columnId, values }) => {
          const column = columns.find(({ id }) => id === columnId);
          return {
            id: column.filterKey,
            values:
              ('filterList' in column || 'getFilterList' in column) != null
                ? values
                : values.map((value) => ([-100, '#EMPTY'].includes(value) ? value : `%${value}%`)),
          };
        }),
      ),
    );
    searchParams.append('pFilterBase64', base64);
  }

  sFilters.forEach(({ values, columnId }) => {
    const column = columns.find(({ id }) => id === columnId);
    if (column) {
      values.forEach((value) => searchParams.append(column.filterKey, String(value)));
    }
  });

  if (opt.filters2.length > 0) {
    opt.filters2.forEach((f, index) => {
      const prefix = `Prop[${index}]`;
      searchParams.append(prefix + '.Id', String(f.columnId));
      searchParams.append(prefix + '.Filter', f.type);
      searchParams.append(prefix + '.Value', f.value);
    });
  }

  return searchParams;
}

export function genericApiErrorHandler(error: any, custom = null): Promise<any> {
  sendError(error, {
    requestId: error?.response?.headers?.requestid,
    requestMethod: error?.config?.method,
    requestPath: error?.config?.url,
    requestData: error?.config?.data && JSON.parse(error?.config?.data),
    message: error?.response?.data,
    custom,
    error,
  });

  throw error;
}

export function errorText() {
  // generic message based on future status response
  // if (status === 400) {}
  // if (status === 500) {}
  return `Ingen endring ble lagret, grunnet ukjent feil. Dokflyt er informert om feilen.`;
}
